export default __webpack_public_path__ + "static/media/truck-site-placeholder.4c05d216.jpg";